import React, { useEffect, useState } from 'react';
import { FormController } from '../Shared/FormController';
import { $FindExistingBillingAccountQuery } from '../../services/V2/gozer';
import { getOperatorConfigs } from './Functions';
import { CircularProgress, Link } from '@mui/material';

export function FindExistingAccount({ findUser, setFindUser, operatorId }) {
    const [faq, setFaq] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() =>{
        setLoading(true);
        getOperatorConfigs()
        .then(x => {
            setFaq(x?.faqUrl);
            setLoading(false);
        })
    }, [])

    return <>
        <div className='text-center'>
            <p><b>Please select your utility provider and enter your account number and account name exactly as it appears on your bill to verify your account.</b></p>
            {faq &&
            <p>
                See our <Link target="_blank" href={faq}><b>User Guide</b></Link> to help locate your account information.
            </p>
            }
            <FormController keys={$FindExistingBillingAccountQuery.properties} model={findUser} setModel={setFindUser} hiddenKeys={["hasuser", "operatorid"]} operatorId={operatorId} />
        </div>
        {loading && <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div>}
    </>

}